import { Box, BoxProps } from '@chakra-ui/react';
import { useMeasure } from 'react-use';

import { NewsletterSubscriptionDecorationShape as Shape } from './Shape';

const DEFAULT_CIRCLES = [0.09829, 0.10256, 0.09829, 0.09829];
const POSITION_OFFSET = 0.25;

export type NewsletterSubscriptionDecorationProps = BoxProps & {
  circles?: number[];
  animate?: boolean;
};

export const NewsletterSubscriptionDecoration = ({
  circles,
  position,
  animate,
  ...boxProps
}: NewsletterSubscriptionDecorationProps) => {
  const [element, { height }] = useMeasure<HTMLDivElement>();

  const sizes = (circles || DEFAULT_CIRCLES).reduce<number[]>(
    (sizes, thickness, index) => (index ? [...sizes, sizes[index - 1] - thickness * 2] : [1]),
    [],
  );

  const holeSize = (circles || DEFAULT_CIRCLES).reduce(
    (size, thickness) => size - thickness * 2,
    1,
  );

  return (
    <Box
      ref={element}
      aria-hidden
      position={position && position !== 'static' ? position : 'relative'}
      overflow="hidden"
      {...boxProps}
    >
      {sizes.map((size, index) => (
        <Shape
          key={index}
          height={`${size * 100}%`}
          position="absolute"
          top="50%"
          left={`${((height - height * size) * (1 + POSITION_OFFSET)) / 2}px`}
          right={0}
          transform="translateY(-50%)"
          rotation={index * 38}
          animate={animate}
        />
      ))}

      <Shape
        color="gray.1"
        height={`${holeSize * 100}%`}
        position="absolute"
        top="50%"
        left={`${((height - height * holeSize) * (1 + POSITION_OFFSET)) / 2}px`}
        right={0}
        transform="translateY(-50%)"
      />
    </Box>
  );
};
